// extracted by mini-css-extract-plugin
export var message = "_1PDH-hmX";
export var note = "imcq-N04";
export var tip = "pLseax0W";
export var warning = "+NQb-RFR";
export var important = "Rcvg+Sdc";
export var messageTitle = "sbs10sQV";
export var messageBody = "j-BPumsl";
export var messageIcon = "VvN+Tfyc";